import React, {useState, useEffect} from 'react';
import Navbar from '../components/Internal-nav';  
import CountertopCard from '../components/countertop-card';
import CountertopData from '../data/countertopdata.json';
import ContactBanner  from "../components/contact-banner";
import KometsBanner from '../components/komets-banner';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';

function Countertop() {
  const [filteredCountertop, setFilteredCountertop] = useState(null);
  useEffect(() => {
    setFilteredCountertop(CountertopData.Countertops.filter(ptype => ptype.page === "multifamily" || ptype.page === "all"));
  }, []);

  function filterCountertop(ctype) {
    let fcountertops = CountertopData.Countertops.filter(ctop => ctop.type === ctype).filter(ptype => ptype.page === "multifamily" || ptype.page === "all");
    return fcountertops;
  }

  function handleCountertop(e) {
    let typeCountertop = e.target.value;
    typeCountertop !== "all"
      ? setFilteredCountertop(filterCountertop(typeCountertop))
      : setFilteredCountertop(CountertopData.Countertops.filter(ptype => ptype.page === "multifamily" || ptype.page === "all"));
  }

  const description = "Discover our premium collection of granite and quartz countertops for multi-family properties. Find durable, stylish options that enhance your space.";
  const keywords = "kitchen countertops, granite countertops, quartz countertops, multi-family countertops, Fort Wayne, Indiana, home improvement";

  return (
    <div className='App'>
      <SEO 
        title="Multi-Family Countertops"
        description={description}
        keywords={keywords}
        canonicalUrl="https://bcsupply.com/countertops"
        ogImage="/assets/example-countertop-banner.jpg"
      />
      <StructuredData 
        type="CollectionPage"
        name="BC Supply Multi-Family Countertops Collection"
        description={description}
      />
      <header>
        <Navbar />
      </header>
      <div>
        <div className='inner-banner' style={{ backgroundImage: "url(../assets/example-countertop-banner.jpg)"}}>
          <div className='banner-content'>
            <h1>Explore our Multi-Family Countertop Options</h1>
          </div>
        </div>
        <div className='countertop-filter'>
          <div className='filter-content'>
            <h2>Choose your countertop material: </h2>
          </div>
          <div className='filter-buttons'>
            <button value="all" onClick={handleCountertop}>All</button>
            <button value="granite" onClick={handleCountertop}>Granite</button>
            <button value="quartz" onClick={handleCountertop}>Quartz</button>
          </div>
        </div>
        <div className='countertop-list'>
          {filteredCountertop ? 
            filteredCountertop.map((d,i) => (
              <CountertopCard key={i} data={d}></CountertopCard>
            ))
            : 'loading'}
        </div>
        <ContactBanner></ContactBanner>
      </div>
      <KometsBanner></KometsBanner>
    </div>
  );
}

export default Countertop;